/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const o = "numerictextbox.increment", e = "numerictextbox.decrement", t = "slider.increment", r = "slider.decrement", a = "slider.dragTitle", l = "colorGradient.r", n = "colorGradient.g", i = "colorGradient.b", c = "colorGradient.a", s = "colorGradient.hex", d = "colorGradient.contrastRatio", G = "colorGradient.colorGradientAALevel", u = "colorGradient.colorGradientAAALevel", p = "colorGradient.colorGradientPass", A = "colorGradient.colorGradientFail", C = "colorGradient.hueSliderLabel", P = "colorGradient.alphaSliderLabel", g = "colorGradient.toggleInputsButton", k = "flatColorPicker.cancelBtn", x = "flatColorPicker.applyBtn", b = "flatColorPicker.colorGradientBtn", m = "flatColorPicker.colorPaletteBtn", B = "flatColorPicker.clearBtn", h = "colorPicker.adaptiveTitle", v = "checkbox.validation", f = "checkbox.optionalText", L = "radioButton.validation", w = "switch.validation", T = "colorPicker.dropdownButtonAriaLabel", D = "rating.ariaLabel", V = "signature.clear", y = "signature.maximize", z = "signature.minimize", I = {
  [o]: "Increase value",
  [e]: "Decrease value",
  [t]: "Increase",
  [r]: "Decrease",
  [a]: "Drag",
  [l]: "r",
  [n]: "g",
  [i]: "b",
  [c]: "a",
  [s]: "hex",
  [d]: "Contrast ratio",
  [G]: "AA",
  [u]: "AAA",
  [p]: "Pass",
  [A]: "Fail",
  [C]: "Hue slider",
  [P]: "Alpha slider",
  [g]: "Toggle colorgradient inputs",
  [k]: "Cancel",
  [x]: "Apply",
  [b]: "Color Gradient view",
  [m]: "Color Palette view",
  [B]: "Clear color value",
  [h]: "Choose color",
  [v]: "Please check this box if you want to proceed!",
  [f]: "(Optional)",
  [L]: "Please select option if you want to proceed!",
  [w]: "Please turn on if you want to proceed!",
  [T]: "Select",
  [D]: "Rating",
  [V]: "Clear",
  [y]: "Maximize",
  [z]: "Minimize"
};
export {
  f as checkboxOptionalText,
  v as checkboxValidation,
  c as colorGradientA,
  u as colorGradientAAALevel,
  G as colorGradientAALevel,
  P as colorGradientAlphaSliderLabel,
  i as colorGradientB,
  d as colorGradientContrastRatio,
  A as colorGradientFail,
  n as colorGradientG,
  s as colorGradientHex,
  C as colorGradientHueSliderLabel,
  p as colorGradientPass,
  l as colorGradientR,
  g as colorGradientToggleInputsButton,
  h as colorPickerAdaptiveTitle,
  T as colorPickerDropdownButtonAriaLabel,
  x as flatColorPickerApplyBtn,
  k as flatColorPickerCancelBtn,
  B as flatColorPickerClearBtn,
  b as flatColorPickerColorGradientBtn,
  m as flatColorPickerColorPaletteBtn,
  I as messages,
  e as numericDecreaseValue,
  o as numericIncreaseValue,
  L as radioButtonValidation,
  D as ratingAriaLabel,
  V as signatureClear,
  y as signatureMaximize,
  z as signatureMinimize,
  r as sliderDecreaseValue,
  a as sliderDragTitle,
  t as sliderIncreaseValue,
  w as switchValidation
};
